import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { AfterLoginHeader } from '../../../stories/AfterLoginHeader/AfterLoginHeader'
import { MobileFilter } from '../../../stories/MobileFilter/MobileFilter'
import CustomMap from '../../../components/CustomMap/CustomMap'
import classes from './Search.module.css'
import { CoachDetailCard } from '../../../stories/CoachDetailCard/CoachDetailCard'

function Search() {
    const [selectedFilter, setSelectedFilter] = useState('Male')
    const filtersData = ['My filters', 'Focus tags', 'Price range', 'Distance', 'Schedule', 'Male', 'Specialties']

    // For location
    const [myCoords, setCoords] = useState({ lat: 40.73061, lng: -73.935242 });

    function getLocation() {
        navigator.geolocation.getCurrentPosition((pos) => {
            setCoords({ lat: pos.coords.latitude, lng: pos.coords.longitude });
        });
    }
    useEffect(() => {
        getLocation();
    }, []);

    return (
        <div className={classes.searchResults}>
            <AfterLoginHeader customStyle={{ maxWidth: '100%', borderBottom: "1px solid #EBEBEB" }} onSubmitSearch={() => console.log('')} showSearch />
            <Container fluid className={classes.container}>
                <Row>
                    <Col md={8}>
                        <Row className='g-0'>
                            <Col md={12} className={classes.mt24}>
                                <MobileFilter filters={filtersData} state={selectedFilter} setter={setSelectedFilter} />
                            </Col>
                            <Col md={12} className={classes.mt24}>
                            <CoachDetailCard/>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={4}>
                        <CustomMap myCoords={myCoords} />

                    </Col>
                </Row>

            </Container>

        </div>
    )
}

export default Search